import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { ProductListType, ProductType, ProductEanType } from 'src/types/product';
import Detail from './Detail';
import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import {
    ProductChangelogType,
    ProductOrdersType,
    ProductReceivingsType,
    ProductStockMovementsType,
    ProductReturnsType,
} from 'src/types/productDetail';
import HistoryBlock from './HistoryBlock';
import ProductStockMovementsTable from './ProductStockMovementsTable';
import ProductReceivingsTable from './ProductReceivingsTable';
import ProductOrdersTable from './ProductOrdersTable';
import ProductReturnsTable from './ProductReturnsTable';
import ProductRelations from './ProductRelations';
import NewProductRelationBlock from './NewProductRelationBlock';
import ProductSetTab from './ProductSetTab';
import EansTab from './EansTab';
import { sizes } from 'src/themes/default';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { UserSettingsType } from 'src/types/userSettings';
import { EditKeysType } from './constants';
import { GridRequestType, ProductDetailGridTableRefType } from 'src/types/table';

export interface RenderComponentsPropsType {
    data: ProductType | null;
    onChange: OnChangeType<EditKeysType>;
    onChangeMultiple: (updates: Partial<ProductType>) => void;
    editData: ProductType;
    editErrors: FormErrorsType;
    newProduct: boolean;
    disableEdit: boolean;
    activeTab: string;
    changelog: ProductChangelogType | null;
    formRef: React.RefObject<HTMLFormElement>;
    permissionQuantityConversion: boolean;
    permissionGlobalProduct: boolean;
    permissionEditDimensionsWeight: boolean;
    permissionExpMethodEdit: boolean;
    productTypeCodes: ConstantsCodeType[];
    productTypeCodesObject: ConstantsCodesObjectType;
    boolNumberCodes: ConstantsCodeType[];
    boolNumberCodesObject: ConstantsCodesObjectType;
    scanImeiSnCodes: ConstantsCodeType[];
    scanImeiSnCodesObject: ConstantsCodesObjectType;
    activeNumberCodes: ConstantsCodeType[];
    batteryTypeCodes: ConstantsCodeType[];
    batteryTypeCodesObject: ConstantsCodesObjectType;
    activeNumberCodesObject: ConstantsCodesObjectType;
    productInsetTypeCodes: ConstantsCodeType[];
    productInsetTypeCodesObject: ConstantsCodesObjectType;
    expeditionMethodCodes: ConstantsCodeType[];
    expeditionMethodCodesObject: ConstantsCodesObjectType;
    currencyCodes: ConstantsCodeType[];
    currencyCodesObject: ConstantsCodesObjectType;
    productRelationCodes: ConstantsCodeType[];
    insertByOrderTypeCodes: ConstantsCodeType[];
    insertByOrderTypeCodesObject: ConstantsCodesObjectType;
    productRelationCodesObject: ConstantsCodesObjectType;
    productsListData: ProductListType[] | null;
    dataStockMovements: ProductStockMovementsType | null;
    dataProductReceivings: ProductReceivingsType | null;
    dataProductOrdersGrid: ProductOrdersType | null;
    dataProductReturns: ProductReturnsType | null;
    loading: boolean;
    onFetchStockMovements: (payload: GridRequestType) => void;
    onFetchProductReceivings: (payload: GridRequestType) => void;
    onFetchProductOrdersGrid: (payload: GridRequestType) => void;
    onFetchProductReturns: (payload: GridRequestType) => void;
    stockMovementsTableRef?: React.RefObject<ProductDetailGridTableRefType>;
    productReceivingsTableRef?: React.RefObject<ProductDetailGridTableRefType>;
    productOrdersTableRef?: React.RefObject<ProductDetailGridTableRefType>;
    productReturnsTableRef?: React.RefObject<ProductDetailGridTableRefType>;
    stockMovementTypeCodes: ConstantsCodeType[];
    receivingStatusCodes: ConstantsCodeType[];
    receivingStatusCodesObject: ConstantsCodesObjectType;
    permissionReceivingDetail: boolean;
    permissionReturnDetail: boolean;
    returnStatusCodes: ConstantsCodeType[];
    returnStatusCodesObject: ConstantsCodesObjectType;
    permissionOrderDetail: boolean;
    orderStatusCodes: ConstantsCodeType[];
    orderStatusCodesObject: ConstantsCodesObjectType;
    shipperCodes: ConstantsCodeType[];
    serviceCodes: ConstantsCodeType[];
    paymentCodes: ConstantsCodeType[];
    orderMarketplacesCodes: ConstantsCodeType[];
    userSettingsData: UserSettingsType | null;
    editUserSettings: (newUserSettings: UserSettingsType) => void;
    idProduct: string;
    skladonUser?: number;
    onChangeTab: (value: string) => void;
    canDeactivateRemoveEans: boolean;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    const renderDetail = () => (
        <>
            <form ref={props.formRef}>
                <Detail
                    onChange={props.onChange}
                    onChangeMultiple={props.onChangeMultiple}
                    editData={props.editData}
                    editErrors={props.editErrors}
                    newProduct={props.newProduct}
                    disableEdit={props.disableEdit}
                    permissionQuantityConversion={props.permissionQuantityConversion}
                    permissionGlobalProduct={props.permissionGlobalProduct}
                    permissionEditDimensionsWeight={props.permissionEditDimensionsWeight}
                    permissionExpMethodEdit={props.permissionExpMethodEdit}
                    productTypeCodes={props.productTypeCodes}
                    boolNumberCodes={props.boolNumberCodes}
                    activeNumberCodes={props.activeNumberCodes}
                    scanImeiSnCodes={props.scanImeiSnCodes}
                    batteryTypeCodes={props.batteryTypeCodes}
                    productInsetTypeCodes={props.productInsetTypeCodes}
                    expeditionMethodCodes={props.expeditionMethodCodes}
                    currencyCodes={props.currencyCodes}
                    insertByOrderTypeCodes={props.insertByOrderTypeCodes}
                    onGoToEansTab={() => props.onChangeTab('eans')}
                    skladonUser={props.skladonUser}
                />
            </form>
            {props.editData.INSERT_TYPE === 'specificProduct' && (
                <>
                    {!props.disableEdit && (
                        <FormBlock sx={{ marginTop: sizes.blocks_top_MG, marginBottom: sizes.blocks_top_MG }}>
                            <NewProductRelationBlock
                                productData={props.data}
                                data={props.editData.PRODUCT_RELATIONS_2}
                                productRelationCodes={props.productRelationCodes}
                                onChange={(value: unknown) => props.onChange('PRODUCT_RELATIONS_2', value, false)}
                                disableEdit={props.disableEdit}
                                productsListData={props.productsListData}
                            />
                        </FormBlock>
                    )}
                    <ProductRelations
                        data={props.editData.PRODUCT_RELATIONS_2}
                        productTypeCodes={props.productTypeCodes}
                        productRelationCodes={props.productRelationCodes}
                        onChange={(value: unknown) => props.onChange('PRODUCT_RELATIONS_2', value, false)}
                        disableEdit={props.disableEdit}
                    />
                </>
            )}
        </>
    );

    const renderHistory = () => (
        <HistoryBlock
            changelog={props.changelog}
            productTypeCodesObject={props.productTypeCodesObject}
            productInsetTypeCodesObject={props.productInsetTypeCodesObject}
            boolNumberCodesObject={props.boolNumberCodesObject}
            activeNumberCodesObject={props.activeNumberCodesObject}
            expeditionMethodCodesObject={props.expeditionMethodCodesObject}
            currencyCodesObject={props.currencyCodesObject}
            productRelationCodesObject={props.productRelationCodesObject}
            scanImeiSnCodesObject={props.scanImeiSnCodesObject}
            batteryTypeCodesObject={props.batteryTypeCodesObject}
            insertByOrderTypeCodesObject={props.insertByOrderTypeCodesObject}
            skladonUser={props.skladonUser}
        />
    );

    const renderStockMovements = () => (
        <ProductStockMovementsTable
            ref={props.stockMovementsTableRef}
            data={props.dataStockMovements}
            loading={props.loading}
            onFetchData={props.onFetchStockMovements}
            idProduct={props.idProduct}
            stockMovementTypeCodes={props.stockMovementTypeCodes}
        />
    );

    const renderProductReceivings = () => (
        <ProductReceivingsTable
            ref={props.productReceivingsTableRef}
            data={props.dataProductReceivings}
            loading={props.loading}
            onFetchData={props.onFetchProductReceivings}
            idProduct={props.idProduct}
            receivingStatusCodes={props.receivingStatusCodes}
            receivingStatusCodesObject={props.receivingStatusCodesObject}
            permissionReceivingDetail={props.permissionReceivingDetail}
            userSettingsData={props.userSettingsData}
            editUserSettings={props.editUserSettings}
        />
    );

    const renderProductOrders = () => (
        <ProductOrdersTable
            ref={props.productOrdersTableRef}
            data={props.dataProductOrdersGrid}
            loading={props.loading}
            onFetchData={props.onFetchProductOrdersGrid}
            idProduct={props.idProduct}
            orderStatusCodes={props.orderStatusCodes}
            orderStatusCodesObject={props.orderStatusCodesObject}
            shipperCodes={props.shipperCodes}
            serviceCodes={props.serviceCodes}
            paymentCodes={props.paymentCodes}
            orderMarketplacesCodes={props.orderMarketplacesCodes}
            boolNumberCodes={props.boolNumberCodes}
            currencyCodes={props.currencyCodes}
            permissionOrderDetail={props.permissionOrderDetail}
            userSettingsData={props.userSettingsData}
            editUserSettings={props.editUserSettings}
        />
    );

    const renderProductReturns = () => (
        <ProductReturnsTable
            ref={props.productReturnsTableRef}
            data={props.dataProductReturns}
            loading={props.loading}
            onFetchData={props.onFetchProductReturns}
            idProduct={props.idProduct}
            returnStatusCodes={props.returnStatusCodes}
            returnStatusCodesObject={props.returnStatusCodesObject}
            permissionReturnDetail={props.permissionReturnDetail}
            userSettingsData={props.userSettingsData}
            editUserSettings={props.editUserSettings}
        />
    );

    const renderProductSet = () => (
        <ProductSetTab
            data={props.editData.PRODUCT_SET}
            onChange={(value: unknown) => props.onChange('PRODUCT_SET', value, false)}
            disableEdit={props.disableEdit}
            editErrors={props.editErrors}
        />
    );

    const renderEans = () => (
        <EansTab
            data={props.editData.EANS}
            onChange={(value: ProductEanType[]) => props.onChange('EANS', value, false)}
            disableEdit={props.disableEdit}
            editErrors={props.editErrors}
            canDeactivateRemove={props.canDeactivateRemoveEans}
            productSku={props.editData.SKU}
            eanLockedByWms={props.editData.EAN_LOCKED_BY_DCIX}
        />
    );

    switch (props.activeTab) {
        case 'detail':
            return renderDetail();

        case 'eans':
            return renderEans();

        case 'productSet':
            return renderProductSet();

        case 'stockMovements':
            return renderStockMovements();

        case 'productReceivings':
            return renderProductReceivings();

        case 'productOrders':
            return renderProductOrders();

        case 'productReturns':
            return renderProductReturns();

        case 'history':
        default:
            return renderHistory();
    }
};

export default RenderComponents;
